import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import InfoSetting from './components/InfoSetting';

const MemberInfoSetting = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="會員個資編輯"
          breadcrumbs={[
            {
              name: '會員管理',
            },
            {
              name: '會員個資編輯',
            },
          ]}
        />
        <InfoSetting />
      </Col>
    </Row>
  );
};

export default MemberInfoSetting;
